import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router";

const Portal = lazy(() => import("@/views/Portal"));
const Home = lazy(() => import("./Home"));
const Policy = lazy(() => import("./Policy"));
const Order = lazy(() => import("./Order"));
const Login = lazy(() => import("./Login"));
const AmazonLogin = lazy(() => import("./AmazonLogin"));
const Authorization = lazy(() => import("./Authorization"));
const Accounts = lazy(() => import("./Accounts"));

const withSuspense = (element) => (
    <Suspense fallback={null}>
        {element}
    </Suspense>
);

const PortalRouter = [
    {
        path: "/",
        key: "view",
        element: <Navigate to="/global/index" />,
    },
    {
        path: "/global",
        key: "global",
        element: withSuspense(<Portal />),
        children: [
            {
                path: "index",
                key: "home",
                element: withSuspense(<Home />),
            }, {
                path: "vip/order",
                key: "about",
                element: withSuspense(<Order />),
            }, {
                path: "accounts",
                key: "accounts",
                element: withSuspense(<Accounts />),
            }, {
                path: "policy/:page",
                key: "policy",
                element: withSuspense(<Policy />),
            },
        ]
    }, {
        path: "/login",
        key: "login",
        element: withSuspense(<Login />)
    }, {
        path: "/amazon-login",
        key: "amazonlogin",
        element: withSuspense(<AmazonLogin />)
    }, {
        path: "/authorization",
        key: "authorization",
        element: withSuspense(<Authorization />)
    }
];
export default PortalRouter;
